
































import {Vue, Component} from 'vue-property-decorator';
import ClickOutside from 'vue-click-outside';

@Component({
  directives: {
    ClickOutside
  }
})
export default class RestockContent extends Vue {

  private viewType: 'list' | 'detail' = 'list';
  private created() {
    this.viewType = this.$route.path.includes('detail') ? 'detail' : 'list';
  }
}
